export default __webpack_public_path__ + "img/reviewview-logo.81a89281.jpg";